import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class CommonPrompt extends DataModel {
  static readonly TYPE_ID: string = 'd9193ee780f44f52b0d6d87c1b42b1c9';

  private constructor(
    public readonly eventCategoriesPrompt: string,
    public readonly eventInfoPrompt: string,
    public readonly languagePrompt: string,
    public readonly useEmojiPrompt: string,
    public readonly doNotUseEmojiPrompt: string,
    public readonly otherSpecificationsPrompt: string,
    public readonly lengthPrompt: string,
    public readonly eventTitlePrompt: string,
    public readonly examplesPrompt: string,
    public readonly vocabularyPrompt: string,
  ) {
    super();
  }

  get $typeId(): string {
    return CommonPrompt.TYPE_ID;
  }

  static create(args: {
    eventCategoriesPrompt: string,
    eventInfoPrompt: string,
    languagePrompt: string,
    useEmojiPrompt: string,
    doNotUseEmojiPrompt: string,
    otherSpecificationsPrompt: string,
    lengthPrompt: string,
    eventTitlePrompt: string,
    examplesPrompt: string,
    vocabularyPrompt: string
  }): CommonPrompt {
    return new CommonPrompt(
        args.eventCategoriesPrompt,
        args.eventInfoPrompt,
        args.languagePrompt,
        args.useEmojiPrompt,
        args.doNotUseEmojiPrompt,
        args.otherSpecificationsPrompt,
        args.lengthPrompt,
        args.eventTitlePrompt,
        args.examplesPrompt,
        args.vocabularyPrompt
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): CommonPrompt {
    return CommonPrompt.create({
      eventCategoriesPrompt: MapUtils.getString(map, 'eventCategoriesPrompt'),
      eventInfoPrompt: MapUtils.getString(map, 'eventInfoPrompt'),
      languagePrompt: MapUtils.getString(map, 'languagePrompt'),
      useEmojiPrompt: MapUtils.getString(map, 'useEmojiPrompt'),
      doNotUseEmojiPrompt: MapUtils.getString(map, 'doNotUseEmojiPrompt'),
      otherSpecificationsPrompt: MapUtils.getString(map, 'otherSpecificationsPrompt'),
      lengthPrompt: MapUtils.getString(map, 'lengthPrompt'),
      eventTitlePrompt: MapUtils.getString(map, 'eventTitlePrompt'),
      examplesPrompt: MapUtils.getString(map, 'examplesPrompt'),
      vocabularyPrompt: MapUtils.getString(map, 'vocabularyPrompt'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'eventCategoriesPrompt': this.eventCategoriesPrompt,
      'eventInfoPrompt': this.eventInfoPrompt,
      'languagePrompt': this.languagePrompt,
      'useEmojiPrompt': this.useEmojiPrompt,
      'doNotUseEmojiPrompt': this.doNotUseEmojiPrompt,
      'otherSpecificationsPrompt': this.otherSpecificationsPrompt,
      'lengthPrompt': this.lengthPrompt,
      'eventTitlePrompt': this.eventTitlePrompt,
      'examplesPrompt': this.examplesPrompt,
      'vocabularyPrompt': this.vocabularyPrompt,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    eventCategoriesPrompt = this.eventCategoriesPrompt,
    eventInfoPrompt = this.eventInfoPrompt,
    languagePrompt = this.languagePrompt,
    useEmojiPrompt = this.useEmojiPrompt,
    doNotUseEmojiPrompt = this.doNotUseEmojiPrompt,
    otherSpecificationsPrompt = this.otherSpecificationsPrompt,
    lengthPrompt = this.lengthPrompt,
    eventTitlePrompt = this.eventTitlePrompt,
    examplesPrompt = this.examplesPrompt,
    vocabularyPrompt = this.vocabularyPrompt,
  }: {
    eventCategoriesPrompt?: string,
    eventInfoPrompt?: string,
    languagePrompt?: string,
    useEmojiPrompt?: string,
    doNotUseEmojiPrompt?: string,
    otherSpecificationsPrompt?: string,
    lengthPrompt?: string,
    eventTitlePrompt?: string,
    examplesPrompt?: string,
    vocabularyPrompt?: string
  } = {}): this {
    return CommonPrompt.create({
      eventCategoriesPrompt,
      eventInfoPrompt,
      languagePrompt,
      useEmojiPrompt,
      doNotUseEmojiPrompt,
      otherSpecificationsPrompt,
      lengthPrompt,
      eventTitlePrompt,
      examplesPrompt,
      vocabularyPrompt,
    }) as this;
  }

  isSame(other: CommonPrompt): boolean {
    if(other === this) {
      return true;
    }

    return other.eventCategoriesPrompt === this.eventCategoriesPrompt &&
      other.eventInfoPrompt === this.eventInfoPrompt &&
      other.languagePrompt === this.languagePrompt &&
      other.useEmojiPrompt === this.useEmojiPrompt &&
      other.doNotUseEmojiPrompt === this.doNotUseEmojiPrompt &&
      other.otherSpecificationsPrompt === this.otherSpecificationsPrompt &&
      other.lengthPrompt === this.lengthPrompt &&
      other.eventTitlePrompt === this.eventTitlePrompt &&
      other.examplesPrompt === this.examplesPrompt &&
      other.vocabularyPrompt === this.vocabularyPrompt;
  }
}

export class CommonPromptBuilder extends DataModelBuilder<CommonPrompt> {
  build(context: SerializationContext, map: SerializedData): CommonPrompt {
    return CommonPrompt.fromMap(context, map);
  }
}
